import { CSClient, type CSTypes } from '@tf/api';

export const getDefinitionsQuery = async (revision: string, locale: string): Promise<CSTypes.GetFrontendIrResponse> => {
	const res = await CSClient.getInstance().getFrontendIr({ revision: revision, locale: locale });
	return res.json();
};
